import { PlumbingProduct, SelectedItemMap } from '@common/models';
import { RootState } from '@redux/store';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface PlumbingState {
    selectedPlumbing: SelectedItemMap;
}

const initialState: PlumbingState = {
    selectedPlumbing: new Map(),
};

const plumbingSlice = createSlice({
    name: 'plumbing',
    initialState,
    reducers: {
        addSelectedPlumbing: (state, action: PayloadAction<PlumbingProduct>) => {
            const newSelectedPlumbing = new Map(state.selectedPlumbing);
            newSelectedPlumbing.set(action.payload.productId, {
                quantity: 0,
                isSelected: true,
                isManuallyChanged: false,
            });

            return {
                ...state,
                selectedPlumbing: newSelectedPlumbing,
            };
        },
        removeSelectedPlumbing: (state, action: PayloadAction<PlumbingProduct>) => {
            const newSelectedPlumbing = new Map(state.selectedPlumbing);
            newSelectedPlumbing.delete(action.payload.productId);

            return {
                ...state,
                selectedPlumbing: newSelectedPlumbing,
            };
        },
        resetSelectedPlumbing: (state) => {
            state.selectedPlumbing = initialState.selectedPlumbing;
        },
        updateSelectedPlumbing: (state, action: PayloadAction<SelectedItemMap>) => {
            state.selectedPlumbing = action.payload;
        },
    },
});

export const { addSelectedPlumbing, removeSelectedPlumbing, resetSelectedPlumbing, updateSelectedPlumbing } =
    plumbingSlice.actions;

export const selectSelectedPlumbing = ({ plumbing }: RootState): SelectedItemMap => plumbing.selectedPlumbing;

export default plumbingSlice.reducer;
